module.exports = __webpack_public_path__ + "img/school.c74051df.jpg";